import React from 'react';
import logo from '../../assets/img/logo-full.png';
import '../../assets/css/login.css';
import { Link } from 'react-router-dom';

const Welcome = () => {
    return (
        <div className="main-container">
            <div className="welcome-container">
                <img className="welcome-logo" src={logo} />

                <h2 className="welcome-title">
                    Meet Your College Sweetheart
                </h2>

                <div className="welcome-form">
                    <Link to="/account/register" className="welcome-btn">
                        Join
                    </Link>

                    <Link to="/account/login" className="welcome-btn" href="#">
                        Sign In
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default Welcome;
